<template>
  <div v-if="texto" class="observacao">
    <label>OBSERVAÇÕES</label> 
    <p v-html="strReplace(texto,'<a','<a target=\'_blank\' ')"></p>     
  </div>
</template>

<script>
import stringFormatMixin from '@/mixins/stringFormatMixin'

export default {
  mixins: [stringFormatMixin],
  name: 'Observacoes',
  props: {
    texto: String
  },

  data() {
    return {
      
    };
  },

  mounted() {
    
  },

  methods: {
    
  },
};
</script>

<style lang="scss" scoped>
.observacao {
  label {
    font-size: 1rem;
    font-weight: 600;
  }
}
</style>